import { TextareaAutosize, styled } from "@mui/material";

interface StyledTextareaProps {
  isError?: boolean;
  isActive?: boolean;
  isEmpty?: boolean;
}

const StyledTextarea = styled(TextareaAutosize, {
  shouldForwardProp: (prop) =>
    prop !== "isError" && prop !== "isActive" && prop !== "isEmpty",
})<StyledTextareaProps>`
  && {
    resize: none;
  }

  width: 17.143rem;
  border-radius: ${(props) => props.theme.wsc.radius.m};
  padding: ${(props) => props.theme.wsc.spacing[1]};
  background-color: ${(props) => props.theme.wsc.palette.neutral[700]};
  border: 1px solid
    ${(props) =>
      props.isError
        ? props.theme.wsc.palette.warning[300]
        : props.isActive
          ? props.theme.wsc.palette.neutral[0]
          : `${props.theme.wsc.palette.neutral[500]}`};
  color: ${(props) => props.theme.wsc.palette.neutral[100]};
  ${(props) => props.theme.wsc.typography.body1};
  caret-color: ${({ theme }) => theme.wsc.palette.primary[300]};

  ::placeholder {
    color: ${(props) => props.theme.wsc.palette.neutral[200]};
  }

  :hover {
    &:not(:focus):not(:disabled) {
      background-color: ${(props) => props.theme.wsc.palette.neutral[600]};
    }
  }

  :focus {
    background-color: ${({ theme }) => theme.wsc.palette.neutral[500]};
    border: 1px solid
      ${(props) =>
        props.isError
          ? props.theme.wsc.palette.warning[300]
          : `${props.theme.wsc.palette.neutral[100]}`};

    &::placeholder {
      color: ${(props) => props.theme.wsc.palette.neutral[300]};
    }
  }

  :focus-visible {
    outline: none;
  }

  :disabled {
    background-color: ${(props) => props.theme.wsc.palette.neutral[800]};
    color: ${(props) => props.theme.wsc.palette.neutral[300]};

    -webkit-text-fill-color: ${(props) => props.theme.wsc.palette.neutral[300]};

    &::placeholder {
      opacity: 0.5;
    }
  }

  /* Prevents webkit browsers from applying their default white background on autofill */
  :-webkit-autofill,
  :-webkit-autofill:focus {
    transition:
      background-color 0s 600000s,
      color 0s 600000s !important;
    color-scheme: dark;
  }
`;

export default StyledTextarea;
